import { Component, JSX, splitProps } from 'solid-js';
import { Dynamic } from 'solid-js/web';

interface SvgIconProps extends JSX.SvgSVGAttributes<SVGSVGElement> {
  icon: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
}

function SvgIcon(props: SvgIconProps) {
  const [local, others] = splitProps(props, ['icon', 'class']);

  return (
    <Dynamic
      component={local.icon}
      {...others}
      class={cx('fill-[currentColor] [&>*]:fill-[currentColor]', local.class)}
    />
  );
}

export default SvgIcon;
